import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from '../../Style/MoaStyled';
import Chip from '@mui/material/Chip';
var getSeverityBgColor = function (severity) {
    switch (severity) {
        case 'success': return '#2e7d32';
        case 'error': return '#D32F2F';
        case 'warning': return '#ed6c02';
        case 'info': return '#0288d1';
        default: return 'rgba(0, 0, 0, 0.08)';
    }
};
var getSeverityColor = function (severity) {
    switch (severity) {
        case 'success':
        case 'error':
        case 'warning':
        case 'info':
            return '#fff';
        default: return '#000';
    }
};
var StyledComponent = styled(function (props) {
    var id = props.id, severity = props.severity, bgColor = props.bgColor, color = props.color, size = props.size, label = props.label, disabled = props.disabled, rest = __rest(props, ["id", "severity", "bgColor", "color", "size", "label", "disabled"]);
    return (_jsx(Chip, { id: id, sx: {
            backgroundColor: bgColor || getSeverityBgColor(severity),
            color: color || getSeverityColor(severity),
        }, size: size, label: label, disabled: disabled }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
